import React from 'react';
import AttachmentThumbnail from './AttachmentThumbnail';

/**
 * FilePreview Component
 *
 * ChatGPT-style thumbnail grid display
 * Shows actual image previews or video icons
 * Max 4 attachments supported
 *
 * @param {Array} attachments - Array of attachment objects (max 4)
 * @param {Function} onRemove - Callback when remove button clicked (index)
 * @param {boolean} uploading - Whether a file is currently uploading
 * @param {number} uploadProgress - Upload progress 0-100
 */
const FilePreview = ({ attachments, onRemove, uploading = false, uploadProgress = 0 }) => {
  // Show nothing if no attachments AND not uploading
  if ((!attachments || attachments.length === 0) && !uploading) {
    return null;
  }

  // Limit to 4 attachments
  const displayAttachments = (attachments || []).slice(0, 4);

  return (
    <div className="attachment-preview-grid">
      {/* Show existing attachments */}
      {displayAttachments.map((attachment, index) => (
        <AttachmentThumbnail
          key={`attachment-${index}-${attachment.filename}`}
          attachment={attachment}
          onRemove={() => onRemove(index)}
          uploading={false}
          uploadProgress={0}
        />
      ))}

      {/* Show uploading placeholder as NEW thumbnail (if uploading and room for more) */}
      {uploading && displayAttachments.length < 4 && (
        <AttachmentThumbnail
          key="uploading-placeholder"
          attachment={{
            type: 'image',
            url: null,
            filename: 'Uploading...',
            size: 0
          }}
          onRemove={() => {}}
          uploading={true}
          uploadProgress={uploadProgress}
        />
      )}
    </div>
  );
};

export default React.memo(FilePreview);
